'use client';

import { Skeleton } from '@wwe-portal/ui/components/skeleton';
import { cn } from '@wwe-portal/ui/lib/lib';
import { useState } from 'react';
import { TextAvatar } from './text-avatar';
import Image from 'next/image';
import { PlayerLink } from '../link/player-link';
import { getPlayerProfileImageUrl } from '@wwe-portal/web/utils/avatar';

export const PlayerAvatar: React.FC<{
  userId?: string | number;
  userName: string | undefined;
  className?: string;
  asLink?: boolean;
}> = ({ userId, userName, className, asLink = true }) => {
  const image = <PlayerAvatarImage userId={userId} userName={userName} />;

  return (
    <div
      className={cn(
        'border-blue500 relative overflow-hidden rounded-full border',
        className
      )}
    >
      {asLink ? <PlayerLink name={userName}>{image}</PlayerLink> : image}
    </div>
  );
};

export const PlayerAvatarImage: React.FC<{
  userId?: string | number;
  width?: number;
  height?: number;
  userName?: string;
  className?: string;
}> = ({ userId, width = 32, height = 32, userName, className }) => {
  const [isError, setIsError] = useState(false);
  if (!userId)
    return (
      <Skeleton
        className={cn('h-full w-full overflow-hidden rounded-full', className)}
      />
    );

  if (isError)
    return (
      <TextAvatar
        className={cn(
          'flex h-full w-full items-center justify-center overflow-hidden rounded-full',
          className
        )}
        text={(userName ?? userId).toString()}
      />
    );
  return (
    <Image
      src={getPlayerProfileImageUrl(`${userId}`)}
      alt="player avatar"
      className={cn('h-full w-full overflow-hidden rounded-full', className)}
      width={width}
      height={height}
      onError={() => setIsError(true)}
      priority={false}
    />
  );
};
